/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import pMinDelay from 'p-min-delay';
import AppliedRoute from './components/AppliedRoute';
import AuthenticatedRoute from './components/AuthenticatedRoute';
import UnauthenticatedRoute from './components/UnauthenticatedRoute';
import LoadingComponent from './components/LoadingComponent';

const delayFn = (promise, minDelay = 1000) => {
    return pMinDelay(promise, minDelay);
};

const Barcodes = Loadable({
    loader: () => { return delayFn(import('./containers/Barcodes')); },
    loading: LoadingComponent,
});
const BarcodePromotions = Loadable({
    loader: () => { return delayFn(import('./containers/BarcodePromotions')); },
    loading: LoadingComponent,
});
const Billing = Loadable({
    loader: () => { return delayFn(import('./containers/Billing')); },
    loading: LoadingComponent,
});
const BulkMessages = Loadable({
    loader: () => { return delayFn(import('./containers/BulkMessages')); },
    loading: LoadingComponent,
});
const ChangePassword = Loadable({
    loader: () => { return delayFn(import('./containers/ChangePassword')); },
    loading: LoadingComponent,
});
const Checkout = Loadable({
    loader: () => { return delayFn(import('./containers/Checkout')); },
    loading: LoadingComponent,
});
const ConfirmPurchase = Loadable({
    loader: () => { return delayFn(import('./containers/ConfirmPurchase')); },
    loading: LoadingComponent,
});
const Customers = Loadable({
    loader: () => { return delayFn(import('./containers/Customers')); },
    loading: LoadingComponent,
});
const Dashboard = Loadable({
    loader: () => { return delayFn(import('./containers/Dashboard')); },
    loading: LoadingComponent,
});
const Home = Loadable({
    loader: () => { return delayFn(import('./containers/Home')); },
    loading: LoadingComponent,
});
const NotFound = Loadable({
    loader: () => { return delayFn(import('./containers/NotFound')); },
    loading: LoadingComponent,
});
const Products = Loadable({
    loader: () => { return delayFn(import('./containers/Products')); },
    loading: LoadingComponent,
});
const Promotions = Loadable({
    loader: () => { return delayFn(import('./containers/Promotions')); },
    loading: LoadingComponent,
});
const PasswordRecovery = Loadable({
    loader: () => { return delayFn(import('./containers/PasswordRecovery')); },
    loading: LoadingComponent,
});
const Pulse = Loadable({
    loader: () => { return delayFn(import('./containers/Pulse')); },
    loading: LoadingComponent,
});
const Report = Loadable({
    loader: () => { return delayFn(import('./containers/Report')); },
    loading: LoadingComponent,
});
const Review = Loadable({
    loader: () => { return delayFn(import('./containers/Review')); },
    loading: LoadingComponent,
});
const Settings = Loadable({
    loader: () => { return delayFn(import('./containers/Settings')); },
    loading: LoadingComponent,
});
const ShopifyCheckout = Loadable({
    loader: () => { return delayFn(import('./containers/ShopifyCheckout')); },
    loading: LoadingComponent,
});
const Retargeting = Loadable({
    loader: () => { return delayFn(import('./containers/Retargeting')); },
    loading: LoadingComponent,
});
const ShopifyBilling = Loadable({
    loader: () => { return delayFn(import('./containers/Shopify/ShopifyBilling')); },
    loading: LoadingComponent,
});
const ShopifyIntegrationPrivate = Loadable({
    loader: () => { return delayFn(import('./containers/Shopify/ShopifyIntegrationPrivate')); },
    loading: LoadingComponent,
});
const ShopifyIntegrationPublic = Loadable({
    loader: () => { return delayFn(import('./containers/Shopify/ShopifyIntegrationPublic')); },
    loading: LoadingComponent,
});
const ShopifyRouter = Loadable({
    loader: () => { return delayFn(import('./containers/Shopify/ShopifyRouter')); },
    loading: LoadingComponent,
});
const ShopifySignup = Loadable({
    loader: () => { return delayFn(import('./containers/Shopify/ShopifySignup')); },
    loading: LoadingComponent,
});
const Signout = Loadable({
    loader: () => { return delayFn(import('./containers/Signout')); },
    loading: LoadingComponent,
});
const Signup = Loadable({
    loader: () => { return delayFn(import('./containers/Signup')); },
    loading: LoadingComponent,
});
const Stores = Loadable({
    loader: () => { return delayFn(import('./containers/Stores')); },
    loading: LoadingComponent,
});
const Winback = Loadable({
    loader: () => { return delayFn(import('./containers/Winback')); },
    loading: LoadingComponent,
});

const Routes = ({ childProps }) => {
    return (
        <Switch>
            {/* Find Your Envy */}
            <UnauthenticatedRoute path="/signup/fye" exact component={Signup} props={childProps} />
            <UnauthenticatedRoute path="/signup/fye10" exact component={Signup} props={childProps} />
            <AuthenticatedRoute path="/store/dashboard/fye" exact component={Dashboard} props={childProps} />
            <AuthenticatedRoute path="/store/barcodes/fye" exact component={Barcodes} props={childProps} />
            <AuthenticatedRoute path="/store/bulk-messages/fye" exact component={BulkMessages} props={childProps} />
            <AuthenticatedRoute
                path="/store/barcode-promotions/fye"
                exact
                component={BarcodePromotions}
                props={childProps}
            />

            {/* merchant website */}
            <UnauthenticatedRoute path="/" exact component={Home} props={childProps} />
            <UnauthenticatedRoute path="/signup" exact component={Signup} props={childProps} />
            <UnauthenticatedRoute path="/shopify/signup" exact component={ShopifySignup} props={childProps} />
            <UnauthenticatedRoute path="/password-recovery" exact component={PasswordRecovery} props={childProps} />
            <AuthenticatedRoute path="/pulse" exact component={Pulse} props={childProps} />
            <AuthenticatedRoute path="/store/dashboard" exact component={Dashboard} props={childProps} />
            <AuthenticatedRoute path="/store/customers" exact component={Customers} props={childProps} />
            <AuthenticatedRoute path="/store/report" exact component={Report} props={childProps} />
            <AuthenticatedRoute path="/store/products" exact component={Products} props={childProps} />
            <AuthenticatedRoute path="/store/barcodes" exact component={Barcodes} props={childProps} />
            <AuthenticatedRoute
                path="/store/barcode-promotions"
                exact
                component={BarcodePromotions}
                props={childProps}
            />
            <AuthenticatedRoute path="/settings" exact component={Settings} props={childProps} />
            <AuthenticatedRoute path="/retargeting" exact component={Retargeting} props={childProps} />
            <AuthenticatedRoute path="/billing" exact component={Billing} props={childProps} />
            <AuthenticatedRoute path="/promotions" exact component={Promotions} props={childProps} />
            <AuthenticatedRoute path="/store/bulk-messages" exact component={BulkMessages} props={childProps} />
            <AuthenticatedRoute path="/winback" exact component={Winback} props={childProps} />
            <AuthenticatedRoute path="/store/stores" exact component={Stores} props={childProps} />
            <AuthenticatedRoute path="/shopify/integration" component={ShopifyIntegrationPrivate} props={childProps} />
            <AuthenticatedRoute path="/reviews" exact component={Review} props={childProps} />
            <AuthenticatedRoute path="/shopify/checkout" exact component={ShopifyCheckout} props={childProps} />
            <AppliedRoute path="/shopify/billing" exact component={ShopifyBilling} props={childProps} />
            <AppliedRoute path="/shopify/int" exact component={ShopifyIntegrationPublic} props={childProps} />
            <AppliedRoute path="/shopify" exact component={ShopifyRouter} props={childProps} />
            <AppliedRoute path="/change-password" exact component={ChangePassword} props={childProps} />
            <AppliedRoute path="/signout" exact component={Signout} props={childProps} />

            {/* customer website */}
            <AppliedRoute path="/checkout/:offer" exact component={Checkout} props={childProps} />
            <AppliedRoute path="/confirm/:offer" exact component={ConfirmPurchase} props={childProps} />

            {/* default */}
            <AppliedRoute component={NotFound} props={childProps} />
        </Switch>
    );
};

Routes.propTypes = {
    childProps: PropTypes.exact({
        cookies: PropTypes.object.isRequired,
        config: PropTypes.object.isRequired,
        isAuthenticated: PropTypes.bool.isRequired,
        isDemoMode: PropTypes.bool.isRequired,
        logoutUser: PropTypes.func.isRequired,
        merchantCode: PropTypes.string.isRequired,
        merchantSettings: PropTypes.shape({
            integrationType: PropTypes.string.isRequired,
            isPriceMatchEnabled: PropTypes.bool.isRequired,
            merchantRegistrationDate: PropTypes.any.isRequired,
            timezone: PropTypes.string.isRequired,
            merchantType: PropTypes.string.isRequired,
        }).isRequired,
        onAuthSuccess: PropTypes.func.isRequired,
        refreshMerchantSettings: PropTypes.func.isRequired,
        reload: PropTypes.func.isRequired,
        user: PropTypes.object,
    }).isRequired,
};

export default Routes;
